export default class SignOff {
    constructor () {

        this.id = null
        this.contact_id = null
        this.project_stage_id = null
        this.name = null
        this.status = "Draft"
    }
}